/* ONAIR fitment directory. Name recognition is NOT suspension compatibility.
   Source listings remain authoritative; related trims always require review. */
(() => {
  'use strict';
  const roman = {i:1,ii:2,iii:3,iv:4,v:5,vi:6,vii:7,viii:8,ix:9,x:10};
  function normalize(value) {
    return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase()
      .replace(/\b(?:mercedes[ -]?benz|mercedes|benz|merc)\b/g,'mercedes')
      .replace(/\b(?:bimmer|beemer|beamer|bwm)\b/g,'bmw')
      .replace(/\b(?:v[ -]?dub|vdub|vw)\b/g,'volkswagen')
      .replace(/\bchevy\b/g,'chevrolet').replace(/\b(?:subie|scooby)\b/g,'subaru')
      .replace(/\b(bug|blob|hawk)[ -]?eye\b/g,'$1eye').replace(/\bm2(?:comp|c)\b/g,'m2 competition').replace(/\bm2cs\b/g,'m2 cs')
      .replace(/\bmitsu\b/g,'mitsubishi').replace(/\bvette\b/g,'corvette')
      .replace(/\bs2k\b/g,'s2000').replace(/\b(?:miata|mx[ -]?5|eunos roadster)\b/g,'mx5')
      .replace(/\brx[ -]?(7|8)\b/g,'rx$1').replace(/\bgt[ -]?r\b/g,'gtr')
      .replace(/\b(?:mark|mk)\s*([ivx]+|\d+(?:\.5)?)\b/g,(_,v)=>'mk'+(roman[v]||v).toString().replace('.','p'))
      .replace(/\b(?:evolution|evo)\s*([ivx]+|\d+)\b/g,(_,v)=>'evo'+(roman[v]||v))
      .replace(/\b(?:evolution|evo)\b/g,'evo')
      .replace(/\b(bmw|audi|lexus)(?=[a-z]?\d)/g,'$1 ')
      .replace(/\bm\s*(\d{3})\s*i\b/g,'m$1i').replace(/\bm\s+([1-8])\b/g,'m$1')
      .replace(/\b(m240|m235)\b/g,'$1i')
      .replace(/\b([efgwzb])\s+(\d{2,3})\b/g,'$1$2')
      .replace(/\b([a-z]{1,3})\s+(\d{1,3})\b/g,(_,a,b)=>['rs','is','ls','gs','rc','q','s','a','c'].includes(a)?a+b:a+' '+b)
      .replace(/\b(\d{3})\s*z\b/g,'$1z').replace(/\bcabrio(?:let)?\b/g,'convertible')
      .replace(/\b4wd\b/g,'awd').replace(/\bfront wheel drive\b/g,'fwd').replace(/\brear wheel drive\b/g,'rwd')
      .replace(/[^a-z0-9]+/g,' ').trim().replace(/\s+/g,' ');
  }
  const yearValue = value => value.length === 4 ? +value : (+value >= 70 ? 1900 : 2000) + +value;
  function years(raw) {
    const text = String(raw).replace(/[–—]/g,'-');
    const bracket = [...text.matchAll(/\[\s*(\d{4})\s*(?:[~\-]\s*(\d{4}|UP|present)?)?\s*\]/gi)].pop();
    const short = !bracket && text.match(/(?:^|\s)(\d{2}|\d{4})\s*[~\-]\s*(\d{2}|\d{4}|UP)?\s*$/i);
    const single = !bracket && !short && text.match(/\b((?:19|20)\d{2})\s*$/);
    const match = bracket || short;
    if (!match && !single) return null;
    const start = yearValue((match||single)[1]);
    let end;
    if (match) end = match[2] && /^\d+$/.test(match[2]) ? yearValue(match[2]) : /[~\-]/.test(match[0]) ? null : start;
    else end = start;
    if (start < 1900 || start > 2099 || (end !== null && (end < start || end > 2099))) return null;
    return {start,end,label:end === null ? start+'+' : end === start ? String(start) : start+' - '+end};
  }
  function makeEntry(make, raw, href) {
    const clean = String(raw).replace(/\*\*/g,'').replace(/^\s*[-•]\s*/,'').replace(/\s+/g,' ').trim();
    const brand = normalize(make);
    const body = normalize(clean);
    const text = body.startsWith(brand+' ') ? body : brand+' '+body;
    const range = years(clean);
    return {make:make==='Bmw'?'BMW':make,brand,raw:clean,href,text,words:new Set(text.split(' ')),range};
  }
  function readDOM(groups) {
    const entries=[]; const seen=new Set();
    for(const group of groups){
      const make=group.querySelector('summary h6,summary h3,summary')?.textContent.trim();
      const body=group.querySelector('.rte');if(!make||!body)continue;
      const clone=body.cloneNode(true);
      clone.querySelectorAll('br').forEach(br=>br.replaceWith('\n'));
      clone.querySelectorAll('li,p').forEach(el=>el.append('\n'));
      const href=body.querySelector('a[href]')?.getAttribute('href')||'/products/air-bags-suspension';
      for(const line of clone.textContent.split('\n')){
        const entry=makeEntry(make,line,href);
        if(entry.raw.length<4||!/[0-9]/.test(entry.raw))continue;
        const key=entry.brand+'|'+normalize(entry.raw);
        if(!seen.has(key)){seen.add(key);entries.push(entry);}
      }
    }
    return entries;
  }
  function contains(entry,tokens){
    return tokens.every(token=>entry.words.has(token)||(!/\d/.test(token)&&token.length>=3&&[...entry.words].some(word=>word.startsWith(token))));
  }
  function inYear(entry,year){return !year || !entry.range || (year>=entry.range.start && (entry.range.end===null||year<=entry.range.end));}
  const names = {
    m2:{title:'BMW M2',brand:'bmw',codes:['F87','G87'],note:'M2 generations are kept separate from standard 2 Series applications. Ask ONAIR to confirm your year, chassis and trim.'},
    m240i:{title:'BMW M240i',brand:'bmw',codes:['F22','F23','G42'],note:'Earlier coupes may be listed under 2 Series 6-cylinder F22. Convertible, xDrive and newer G42 applications need their own confirmation.'},
    m235i:{title:'BMW M235i',brand:'bmw',codes:['F22'],note:'The F22 coupe is distinct from the M235i Gran Coupe. Confirm the chassis and drivetrain before ordering.'},
    bugeye:{title:'Subaru Impreza / WRX - Bugeye',brand:'subaru',codes:['GD','GG'],note:'Nickname recognized. Related generation entries are shown for review; model years and mounting details vary by market.'},
    blobeye:{title:'Subaru Impreza / WRX - Blobeye',brand:'subaru',codes:['GD','GG'],note:'Nickname recognized. Related generation entries are shown for review; model years and mounting details vary by market.'},
    hawkeye:{title:'Subaru Impreza / WRX - Hawkeye',brand:'subaru',codes:['GD','GG'],note:'Nickname recognized. Related generation entries are shown for review; model years and mounting details vary by market.'}
  };
  function search(entries,rawQuery,make='',selectedYear=''){
    let query=normalize(rawQuery);
    const requestedYears=[...query.matchAll(/\b(?:19|20)\d{2}\b/g)].map(m=>+m[0]);
    if(selectedYear)requestedYears.push(+selectedYear);
    const unique=[...new Set(requestedYears)];
    if(unique.length>1)return {direct:[],related:[],error:'Choose one year at a time, and keep the search year and year filter the same.'};
    const year=unique[0]||null;
    query=query.replace(/\b(?:19|20)\d{2}\b/g,'').replace(/\s+/g,' ').trim();
    const tokens=query.split(' ').filter(Boolean);
    const brand=normalize(make);
    const candidates=entries.filter(e=>(!brand||e.brand===brand)&&inYear(e,year));
    const direct=[]; const related=[];
    for(const e of candidates){if(contains(e,tokens))(year&&!e.range?related:direct).push(e);}
    let key=Object.keys(names).find(k=>tokens.includes(k));
    if(!key&&tokens.some(t=>['f87','g87'].includes(t)))key='m2';
    if(!key&&tokens.includes('g42'))key='m240i';
    let recognized=key?{...names[key],key}:null;
    if(recognized){
      const makes=new Set(entries.map(e=>e.brand));
      if((brand&&brand!==recognized.brand)||tokens.some(t=>makes.has(t)&&t!==recognized.brand))recognized=null;
    }
    if(!direct.length&&recognized){
      if(key==='m240i'||key==='m235i'){
        const newer=tokens.includes('g42')||tokens.includes('f44')||tokens.includes('convertible')||(year&&year>=2022)||tokens.includes('gran');
        const validYear=!year||(key==='m240i'?year>=2016:year>=2013);
        if(!newer&&validYear){
          const remaining=tokens.filter(t=>![key,'bmw','xdrive','awd','rwd','coupe'].includes(t));
          for(const e of candidates){if(e.brand==='bmw'&&e.words.has('f22')&&e.words.has('6cyl')&&contains(e,remaining))related.push(e);}
        }
      } else if(['bugeye','blobeye','hawkeye'].includes(key)){
        const remaining=tokens.filter(t=>![key,'wrx','subaru'].includes(t));
        for(const e of candidates){if(e.brand==='subaru'&&(e.words.has('gd')||e.words.has('gg')||e.words.has('gdbf'))&&contains(e,remaining))related.push(e);}
      }
    }
    // A specific BMW badge can lead to its family, but never as an approved badge match.
    if(!direct.length&&!recognized&&(brand==='bmw'||tokens.includes('bmw'))){
      const badge=tokens.find(t=>/^m?[1-8]\d{2}[a-z]{1,3}$/.test(t));
      if(badge){
        const rest=tokens.filter(t=>![badge,'xdrive','awd','rwd'].includes(t));
        for(const e of candidates){if(e.brand==='bmw'&&e.words.has(badge.replace(/^m/,'')[0])&&e.words.has('series')&&contains(e,rest))related.push(e);}
        recognized={title:'BMW '+badge.toUpperCase(),brand:'bmw',codes:[],note:'This badge may be grouped under its Series name. Related entries are not trim or drivetrain approval.'};
      }
    }
    const sort=(a,b)=>a.make.localeCompare(b.make)||a.raw.localeCompare(b.raw,undefined,{numeric:true});
    const dedup=items=>[...new Map(items.map(e=>[e.brand+'|'+e.raw,e])).values()].sort(sort);
    return {direct:direct.sort(sort),related:dedup(related),recognized,year,tokens,query,filter:brand};
  }
  window.ONAIRFitmentCore=Object.freeze({normalize,years,makeEntry,readDOM,search});
})();
